import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-01/lesson-12/task-02";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "Each image below depicts the pressure field due to the reflection and the transmission of a plane wave<br>obliquely incident (15° or 30°) on a flat interface (black vertical line) between two media.",
  description: "Drag images to the correct group of material properties.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [6, 1],
      components: [
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 2,
                rows: 1,
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "image",
                          options: {
                            src: `${config.ASSETS_URL}/01/12/task/task-2-group-1.svg`,
                          },
                        },
                        styles: {
                          padding: "1% 0 1% 15%",
                        },
                      },
                    },
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "image",
                          options: {
                            src: `${config.ASSETS_URL}/01/12/task/task-2-group-2.svg`,
                          },
                        },
                        styles: {
                          padding: "1% 15% 1% 0",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default task;
